/**
 * Shared `<select>` appearance for SRP sort and "last seen" recency controls.
 *
 * Avoids `@container` / `@sm:` breakpoint steps on the control itself: as the SRP island
 * hydrates and layout settles, container width and scrollbar metrics can change slightly and
 * retoggle those variants — causing visible jump.
 * `transition-colors` avoids animating width. Width stays content-driven (`inline-block w-auto`);
 * optional wrappers may set `max-w-*` where a cap is needed. No `truncate` — the wrapping flex
 * row (SearchSidebar's `search-controls`) keeps its default content-based `min-width` on this
 * control instead of `min-w-0`, so the row never squeezes it below its option text's width in
 * the first place; silently ellipsing an already-short sort/recency label just hides information.
 */
const SRP_INLINE_SELECT_BASE =
  'inline-block w-auto max-w-full min-w-0 rounded-jc-field border border-jc-border-control bg-jc-surface px-3 py-2 text-sm font-medium text-jc-ink focus:outline-none focus:ring-2 focus:ring-jc-focus transition-colors duration-200';

/** Interactive sort / recency dropdowns */
export const SRP_INLINE_SELECT_CLASSNAME = `${SRP_INLINE_SELECT_BASE} cursor-pointer`;

/** Non-interactive replica (e.g. static SSR sidebar placeholder). */
export const SRP_INLINE_SELECT_STATIC_CLASSNAME = `${SRP_INLINE_SELECT_BASE} cursor-default`;
